<template>
    <ChartLine :chart-data="chartData" :chart-options="calcOptions" />
</template>

<script>
    import { Line as ChartLine } from 'vue-chartjs'

    export default {
        props: ['datasets', 'labels', 'options'],
        components: {
            ChartLine
        },

        computed: {
            chartData: function() {
                return {
                    datasets: [{
                        label: '',
                        backgroundColor: 'rgba(255,0,0)',
                        borderColor: 'rgba(255,0,0)',
                        data: this.datasets,
                        fill: false
                    }],
                    labels: this.labels
                }
            },

            calcOptions: function() {
                return {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false,
                    },
                    // scales: {
                    //     xAxes: [{
                    //         ticks: {
                    //             fontSize: 10
                    //         }
                    //     }]
                    // }
                }
            }
        }
    }
</script>